import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import dayjs from "dayjs";

import axios from "axios";
import PageTitles from "../components/Layout/PageTitles";

export default function Reports() {
  const [reports, setReports] = React.useState({ usage: [], logs: [] });
  const [err, setErr] = React.useState(null);

  React.useEffect(() => {
    axios
      .get(`/report`)
      .then((res) => {
        setReports(res.data.logsView);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <>
      <PageTitles title={"RiskTree reporting"} />
      <Grid id="i" container spacing={3} direction="row">
        <Grid item id="j" xs>
          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h2>Usage</h2>
              <h3>
                Users logged on since
                {" " + dayjs().subtract(1, "day").format("DD/MM/YYYY")}
              </h3>
              {reports.usage.length > 0 && (
                <List dense>
                  {reports.usage.map((value, index) => {
                    return (
                      <ListItem key={index}>
                        <ListItemText primary={value} />
                      </ListItem>
                    );
                  })}
                </List>
              )}
            </Paper>
          </Grid>

          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h2>Statistics</h2>
              {reports.logs.length > 0 && (
                <List dense>
                  <ListItem key={0}>
                    <ListItemText primary={"Events " + reports.logs.length} />
                  </ListItem>
                  <ListItem key={1}>
                    <ListItemText
                      primary={
                        "Errors " +
                        reports.logs.filter((log) => log.error == "Y").length
                      }
                    />
                  </ListItem>
                </List>
              )}
            </Paper>
          </Grid>

          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h2>Errors</h2>
              {reports.logs.length > 0 && (
                <List dense>
                  {reports.logs
                    .filter((log) => log.error == "Y")
                    .map((log, index) => {
                      return (
                        <ListItem key={index}>
                          <ListItemText primary={log.results} />
                        </ListItem>
                      );
                    })}
                </List>
              )}
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
